import { supabase } from '../supabaseClient';

// Resolve a product_media.storage_path to a browser URL. Bucket paths go
// through Supabase storage as before; full http(s) URLs pass straight
// through — used by the TCGdex seed singles (external CDN images) and handy
// for any future externally-hosted media.
//
// Sizing matters here (09.17.2026): the originals are phone photos, 5712x4284
// and ~3.5MB each, and every surface was serving them raw. A shop grid of 24
// cards was pulling roughly 84MB over a phone connection. Pass a width and the
// URL goes through Supabase's render endpoint instead, which resizes on their
// CDN and hands back WebP to browsers that accept it — the same photo at
// width 600 is about 120KB. Callers pass the width they actually paint.
export function mediaUrl(storagePath, { width, quality = 72 } = {}) {
  if (!storagePath) return null;
  if (/^https?:\/\//.test(storagePath)) return storagePath;
  const file = supabase.storage.from('shinyvault-media');
  if (!width) return file.getPublicUrl(storagePath).data.publicUrl;
  return file.getPublicUrl(storagePath, {
    transform: { width, quality, resize: 'contain' },
  }).data.publicUrl;
}

// Named sizes so the call sites read as intent rather than numbers, and so
// there is one place to retune them.
export const IMG = {
  thumb: { width: 160 },
  card: { width: 600 },
  hero: { width: 1200, quality: 78 },
  zoom: { width: 2200, quality: 82 },
};
